import { useEffect, useRef } from "react";

interface Props {
  handleSeekMouseDown?: (e: any) => void;
  handleSeekMouseUp?: () => void;
  handleSeekChange?: (e: any) => void;
  value: number;
  max: number;
}
const min = 0;
// const max = 15;
const Range: React.FC<Props> = ({
  max,
  value,
  handleSeekChange,
  handleSeekMouseDown,
  handleSeekMouseUp,
}) => {
  const rangeRef = useRef<any>(null);
  useEffect(() => {
    if (rangeRef?.current)
      rangeRef.current.style.backgroundSize =
        ((value - min) * 100) / (max - min) + "% 100%";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div className="audio-player-range" style={{ width: "auto" }}>
      <input
        ref={rangeRef}
        step="any"
        type="range"
        value={value}
        min={min}
        max={max}
        style={{ width: "100%" }}
        onTouchStart={handleSeekMouseDown}
        onTouchEnd={handleSeekMouseUp}
        onMouseDown={handleSeekMouseDown}
        onMouseUp={handleSeekMouseUp}
        onChange={handleSeekChange}
      />
    </div>
  );
};

export default Range;
